import * as React from 'react';

import { IconProps } from './Icon';

export const SyncStatusLoadingOutlineIcon = ({
  width,
  height,
  className,
  color,
}: IconProps) => (
  <svg
    className={className}
    color={color}
    height={height}
    id="Capa_1"
    version="1.1"
    viewBox="0 0 512 512"
    width={width}
    x="0px"
    xmlns="http://www.w3.org/2000/svg"
    y="0px"
  >
    <g>
      <g>
        <g>
          <path
            d="M457.408,264.56c0.176-2.96,0.256-5.776,0.256-8.56c0-97.04-80.32-176-179.008-176
				c-72.32,0-137.376,43.056-165.04,108.16C49.12,197.136,0,248.64,0,309.328C0,376.976,60,432,133.728,432h289.808
				C472.32,432,512,392.928,512,344.896C512,309.12,490.144,277.792,457.408,264.56z M423.552,400H133.728
				C77.648,400,32,359.328,32,309.328c0-47.088,41.296-86.752,94.032-90.304c6.336-0.432,11.84-4.576,13.984-10.576
				C160.64,150.768,216.352,112,278.64,112c81.056,0,147.008,64.592,147.008,144c0,5.344-0.384,11.024-1.248,17.904
				c-1.008,8.128,4.288,15.696,12.256,17.552c25.52,5.936,43.344,27.92,43.344,53.44C480,375.28,454.672,400,423.552,400z"
          />
          <circle cx="192" cy="288" r="16" />
          <circle cx="256" cy="288" r="16" />
          <circle cx="320" cy="288" r="16" />
        </g>
      </g>
    </g>
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
  </svg>
);
